export default "<div id=\"preloader\">\n\t<div id=\"loader\"></div>\n\t<span id=\"loader-text\">{{ text }}</span>\n</div>\n";